<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/playlists"></ion-back-button>
    </ion-buttons>
    <ion-title>Sync Learning</ion-title>
    <ion-buttons slot="end">
      <ion-button *ngIf="isSpotifyConnected" fill="clear" (click)="reconnectSpotify()" aria-label="Reconnect Spotify">
        <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  <!-- ── Not connected ──────────────────────────────────────────────────────── -->
  <div *ngIf="!isSpotifyConnected" class="connect-screen">
    <div class="connect-card">
      <div class="connect-logo">
        <ion-icon name="musical-notes-outline"></ion-icon>
      </div>
      <h2>Sync Learning Mode</h2>
      <p>Connect Spotify to see real-time synced lyrics for whatever you're listening to — with translations.</p>
      <ion-button expand="block" class="spotify-btn" (click)="connectSpotify()">
        Connect Spotify
      </ion-button>
      <p class="connect-note">Requires Spotify (free or premium). A re-login may be needed if you've connected before.</p>
    </div>
  </div>

  <!-- ── Connected ─────────────────────────────────────────────────────────── -->
  <div *ngIf="isSpotifyConnected" class="sync-screen">

    <!-- Now playing bar -->
    <div *ngIf="currentTrack" class="now-playing-bar">
      <img [src]="albumArtUrl(currentTrack)" [alt]="currentTrack.album.name" class="album-art" loading="lazy" />
      <div class="track-info">
        <span class="track-name">{{ currentTrack.name }}</span>
        <span class="artist-name">{{ artistNames(currentTrack) }}</span>
      </div>
      <ion-chip *ngIf="!isPlaying" color="medium" class="paused-chip">Paused</ion-chip>
    </div>

    <!-- Progress bar -->
    <div *ngIf="currentTrack" class="progress-bar-wrapper">
      <div class="progress-bar-track">
        <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
      </div>
      <div class="progress-times">
        <span>{{ formatTime(progressMs) }}</span>
        <span>{{ formatTime(currentTrack.duration_ms) }}</span>
      </div>
    </div>

    <!-- Nothing playing -->
    <div *ngIf="nothingPlaying && !currentTrack" class="empty-state">
      <ion-icon name="headset-outline"></ion-icon>
      <p>Nothing playing on Spotify right now.<br>Start a song in the Spotify app.</p>
    </div>

    <!-- Waiting for first poll -->
    <div *ngIf="!nothingPlaying && !currentTrack && !lyricsLoading" class="empty-state">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Connecting to Spotify…</p>
    </div>

    <!-- Lyrics loading -->
    <div *ngIf="lyricsLoading" class="lyrics-status">
      <ion-spinner name="crescent"></ion-spinner>
      <span>Loading lyrics…</span>
    </div>

    <!-- No synced lyrics available -->
    <div *ngIf="!lyricsLoading && lyricsError && segments.length === 0 && currentTrack" class="lyrics-status">
      <ion-icon name="musical-note-outline"></ion-icon>
      <span>{{ lyricsError }}</span>
    </div>

    <!-- Lyrics toolbar -->
    <div *ngIf="!lyricsLoading && segments.length > 0" class="lyrics-toolbar">
      <ion-button fill="clear" size="small" (click)="toggleTranslations()" [disabled]="translationsLoading">
        <ion-spinner *ngIf="translationsLoading" name="crescent" slot="start" style="width:14px;height:14px;margin-right:4px;"></ion-spinner>
        <span *ngIf="!translationsLoading">{{ translationsVisible ? 'Hide Translations' : 'Show Translations' }}</span>
        <span *ngIf="translationsLoading">Translating…</span>
      </ion-button>
    </div>

    <!-- Lyrics lines -->
    <div *ngIf="!lyricsLoading && segments.length > 0" class="lyrics-scroll">
      <div
        *ngFor="let seg of segments; let i = index"
        class="lyric-line"
        [class.active]="activeIndex === i"
        [class.past]="activeIndex > i"
        [class.near-past]="activeIndex - i === 1 || activeIndex - i === 2"
        [class.near-next]="i - activeIndex === 1 || i - activeIndex === 2"
        [class.upcoming]="i > activeIndex"
        (click)="seekTo(seg)"
        role="button"
        tabindex="0"
        (keydown.enter)="seekTo(seg)">
        <span class="lyric-text">{{ seg.text }}</span>
        <span *ngIf="translationsVisible && translations[i]" class="lyric-translation">
          {{ translations[i] }}
        </span>
      </div>
    </div>

  </div>

</ion-content>
